<template lang="pug">
	.update.mt-2.gray.rounded-lg.rounded-t-none.py-2.self-stretch.border-t.relative
		.flex.justify-between.items-baseline
			p 
				b.mr-1(:style="{ color: color }") {{update.value}}
				span.text-xs.text-gray-6 {{update.unit}}
			
			p.text-xs.text-gray-6 {{when}}
		
		.mt-2
			p {{update.comment}}
		
		.mt-2.flex.justify-between
			.flex.items-center
				Avatar(size="tiny" :profile="profile")
				p.text-xs.ml-1.font-medium.text-gray-6 {{profile.displayName.split(" ")[0]}}

			.relative
				eva-icon.icon.text-gray-5.cursor-pointer(v-if="uid == update.author" name="more-horizotnal" @click="showMoreDropdown = true")
				.dropdown.absolute.right-0.top-0(v-if="showMoreDropdown")
					.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showMoreDropdown = false")
					.relative.bg-white.p-2.shadow-xl.mt-8.rounded-lg.z-10
						p.font-medium.px-2.py-1.rounded-lg.cursor-pointer(class="hover:bg-gray-1" @click="startEditing") Edit
						p.font-medium.px-2.py-1.rounded-lg.cursor-pointer.text-red-7(class="hover:bg-red-1" @click="deleteUpdate") Delete
				
				.dropdown.absolute.right-0.top-0(v-if="showEditDropdown")
					.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="stopEditing")
					form.relative.bg-white.p-2.shadow-xl.mt-8.rounded-lg.z-10.w-64(@submit.prevent="saveUpdate")
						label Target
						input.h-10(v-model="newUpdate.value" @click="select")
						
						label.mt-2 Status
						.flex.p-1.w-full.rounded.bg-gray-1.text-gray-6.uppercase.text-center.text-xs.tracking-wide.cursor-pointer.max-w-sm
							.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{blue: newUpdate.status == 'On track'}" @click="newUpdate.status = 'On track'") On track
							.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{orange: newUpdate.status == 'At risk'}" @click="newUpdate.status = 'At risk'") At risk
							.rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{red: newUpdate.status == 'Off track'}" @click="newUpdate.status = 'Off track'") Off track
						
						label.mt-2 Comment
						textarea.h-32.pt-2(@click="select" v-model="newUpdate.comment" placeholder="Give your teammates some context...")

						button.main.small.mt-2(type="submit") Save update
		
		.blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.justify-center.items-center.-m-1(v-if="loading")
			eva-icon.icon.spin.text-gray-6(name="loader-outline")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Avatar from "./Avatar";
//import Moment from "moment";
import { auth, firestore } from "../firebase.config";
import Moment from "moment-timezone";

export default {
  name: "UpdateCard",
  props: ["update", "krUpdates"],
  components: { Avatar },
  data() {
    return {
      showMoreDropdown: false,
      showEditDropdown: false,
      uid: auth.currentUser.uid,
      loading: false,
      newUpdate: {
        value: "",
        status: "",
        comment: ""
      },
      tempUpdate: null
    };
  },
  computed: {
    ...mapGetters(["company", "profile", "teammates", "updates"]),
    profile() {
      return this.teammates.find(teammate => teammate.id == this.update.author);
    },
    color() {
      switch (this.update.status) {
        case "On track":
          return "#1971c2";
        case "At risk":
          return "#e8590c";
        case "Off track":
          return "#e03131";
        default:
          return "#000";
      }
    },
    when() {
      return Moment(this.update.date.toDate()).fromNow();
    },
    isLatest() {
      if (this.krUpdates[0].id == this.update.id) return true;
      else return false;
    }
  },
  created() {},
  methods: {
    ...mapActions(["select"]),
    startEditing() {
      this.showMoreDropdown = false;

      this.newUpdate.value = this.update.value;
      this.newUpdate.status = this.update.status;
      this.newUpdate.comment = this.update.comment;

      this.showEditDropdown = true;
    },
    stopEditing() {
      this.showEditDropdown = false;

      this.newUpdate.target = "";
      this.newUpdate.status = "";
      this.newUpdate.comment = "";
    },
    saveUpdate() {
      this.loading = true;

      if (!this.newUpdate.value.length) this.newUpdate.value = 0;

      this.showEditDropdown = false;

      Promise.all([
        this.isLatest
          ? this.$store.dispatch("updateDoc", {
              collection: "keyResults",
              id: this.update.kr,
              item: {
                initialValue: this.newUpdate.value,
                status: this.newUpdate.status
              }
            })
          : true,
        this.$store.dispatch("updateDoc", {
          collection: "updates",
          id: this.update.id,
          item: {
            value: this.newUpdate.value,
            comment: this.newUpdate.comment,
            status: this.newUpdate.status
          }
        })
      ])
        .then(() => {
          this.stopEditing();
          this.$store.dispatch("fireNotification", {
            title: "Edited your update",
            type: "success"
          });
          return Promise.all([
            this.isLatest
              ? this.$store.dispatch("getKeyResults", this.profile.companyId)
              : true,
            this.$store.dispatch("getUpdates", this.profile.companyId)
          ]);
        })
        .then(() => {
          this.$emit("done");
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$store.dispatch("fireNotification", {
            title: "Couldn't post update",
            message: "Please check your wifi and try again",
            type: "error",
            icon: "wifi-off"
          });
        });
    },
    deleteUpdate() {
      this.showMoreDropdown = false;

      this.loading = true;
      this.tempUpdate = this.update;

      this.$store
        .dispatch("deleteDoc", {
          collection: "updates",
          id: this.update.id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Deleted update",
            message: "Made a mistake? You can undo",
            timeOut: 7000,
            actions: [
              {
                text: "Undo",
                do: "createDoc",
                payload: {
                  collection: "updates",
                  id: this.update.id,
                  item: this.tempUpdate
                },
                then: "getUpdates",
                thenPayload: this.profile.companyId
              }
            ]
          });
          return this.$store.dispatch("getUpdates", this.profile.companyId);
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="sass" scoped>
//.update
	//&:hover
		//@apply bg-white shadow-lg rounded-t-lg border-t-0
</style>
